/**
 * Draw a border around a rectangle
 * @param {CanvasRenderingContext2D} ctx - Canvas context
 * @param {number} x - X position
 * @param {number} y - Y position
 * @param {number} width - Width
 * @param {number} height - Height
 * @param {number} borderWidth - Border width
 * @param {string} borderColor - Border color
 */
export function createBorder(ctx, x, y, width, height, borderWidth, borderColor = '#FF6DF0') {
  ctx.strokeStyle = borderColor;
  ctx.lineWidth = borderWidth;
  ctx.strokeRect(x, y, width, height);
}
